import { CatLoadingIndicator } from '@blocks-react/components/LoadingIndicator';
import styles from './BestSellerProductsLoader.module.scss';
import cx from 'classnames';

export const BestSellerProductsLoader = () => {
  return (
    <div
      className={cx(
        'w-100 h-100 position-fixed top-0 left-0',
        styles['loader-container']
      )}
    >
      <CatLoadingIndicator className={styles['loader']} />
    </div>
  );
};
